import styled from "styled-components"
import paypalLogo from "@irati-web/payments/src/images/logoPaypal.png"

export const Image = styled.img`
  display: inline;
  height: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
`

export const PayPalLogo = styled.img.attrs({src: paypalLogo})`
  height: 25px;
  margin-top: 12px;
`
